import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalStorage } from '../auth/local.storage';
import { AuthModel, IBasePopWinAuth, CLOUD_PKCE_VERIFIER_KEY } from '../cloud-storage/cloud-auth-base.service';
import { AccountService } from '../auth/account.service';
import { MatDialog } from '@angular/material/dialog';
import { WolandCloudDriveServerConnectionService } from './woland-cloud-drive-server-connection';
import { WolandBaseDriveAuthService } from './base-drive.auth.service';
import { CloudServiceEnum } from '../cloud-storage/enums';

export interface IOneDriveUserPorfile {
  businessPhones: any[];
  displayName: string | null;
  givenName: string | null;
  id: string | null;
  jobTitle: string | null;
  mail: string | null;
  mobilePhone: string | null;
  officeLocation: string | null;
  preferredLanguage: string | null;
  surname: string | null;
  userPrincipalName: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class WolandOneDriveAuthService extends WolandBaseDriveAuthService {
  private authUrl: string = 'https://login.microsoftonline.com/common/oauth2/v2.0';

  private get redirectUri(): string {
    return encodeURI(`${window.location.origin}/${environment.woland.oneDrive.redirectUri}`);
  }

  private get redirectLogoutUri(): string {
    return encodeURI(`${window.location.origin}/cloud-connection-logout/`);
  }

  private get clientId(): string {
    return environment.woland.oneDrive.clientId;
  }

  constructor(
    protected readonly localStorage: LocalStorage,
    protected accountService: AccountService,
    protected dialog: MatDialog,
    protected readonly wolandCloudDriveServerConnectionService: WolandCloudDriveServerConnectionService,
  ) {
    super(localStorage, accountService, wolandCloudDriveServerConnectionService);
  }

  public async authorize(): Promise<void> {
    this.logout();

    const { verifier, challenge, method } = this.generatePkce();
    this.localStorage.set(CLOUD_PKCE_VERIFIER_KEY, verifier);

    const options: AuthModel = {
      //localStorageKey should be empty in this case, setup after request token from server
      localStorageKey: '',
      url: `${this.authUrl}/authorize?client_id=${this.clientId}&scope=${this.getScope()}` +
           `&response_type=code&redirect_uri=${this.redirectUri}&prompt=login` +
           `&code_challenge=${challenge}&code_challenge_method=${method}`,
      windowName: 'OneDriveAuthPopup'
    };

    await super.authorizePopup(options);
  }

  async unAttachDrive(): Promise<void> {
    this.logout();
    const opts: IBasePopWinAuth = {
      url: `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${this.redirectLogoutUri}`,
      windowName: 'OneDriveAuthPopup',
    }
    await this.logoutPopup(opts);
  }

  getScope(): string {
    const scope = environment.woland.oneDrive.scope;
    return encodeURI(scope.join(' '));
  }

  isConnected() {
    let authInfo = this.wolandDriveInfo;
    if (authInfo && authInfo.cloudType === CloudServiceEnum.OneDrive) {
        return true;
    }
    return false;
  }
}

export interface OneDriveAuthorizationCode {
  code: string;
  session_state: string;
}
